export const FETCH_DRAFT_COMPLETED_TASK_LIST_REQUEST = 'FETCH_DRAFT_COMPLETED_TASK_LIST_REQUEST'
export const FETCH_DRAFT_COMPLETED_TASK_LIST_SUCCESS = 'FETCH_DRAFT_COMPLETED_TASK_LIST_SUCCESS'
export const FETCH_DRAFT_COMPLETED_TASK_LIST_FALUIRE = 'FETCH_DRAFT_COMPLETED_TASK_LIST_FALUIRE'
